// extracted by mini-css-extract-plugin
export default {"iframe":"L9gjBo","fillAllSpace":"pbVUCU","absolute":"xJ2LwY"};